import styled from "styled-components";

export const RestoreBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.25rem;
  font-size: 1rem;

  .forgot__block {
    text-align: right;
    min-width: 11.25rem;
  }

  .restore__link {
    text-align: left;
    color: #004581;
    font-weight: 700;
  }
`;


export const FormButtons = styled.div`
  display: flex;
  position: relative;
  justify-content: space-between;
  gap: 1.875rem;

  .reg__btn {
    width: 100%;
    border: 1px solid #004581;

    &:hover {
      background-color: #004581;
      color: #fff;
    }
  }

  .log__btn {
    width: 100%;
    color: #fff;
    background-color: #004581;
    border: 1px solid #004581;

    &:hover {
      background-color: #fff;
      color: #004581;
    }
  }
`;
